import { Injectable } from '@angular/core';
import { ENV } from 'environments/environment';
import { CONSTANTS } from 'environments/common';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class OdsService {

  constructor(private http: HttpClient) { }


  getOdsActive(dataIn) {

    let url = ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.ODS.GET_ODS_ACTIVE + '/odsActive?eventName=' + dataIn.eventName;

    return this.http.get(url, dataIn);
  }


  getOds(dataIn) {

    let url = ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.ODS.GET_ODS + '/' + dataIn.exhibitorId + '/ods';

    return this.http.get(url, dataIn);
  }


}
